import { LOCALES } from '@marketplace/i18n';

export const landingPageMainSection = {
  [LOCALES.ENG]: {
    developer_landing_main_section_button: 'Learn more',
    developer_landing_main_section_button_capitalized: 'Learn More',

    developer_landing_main_section_title: 'FHIR power',
    developer_landing_main_section_description:
      "Whether you are a patient, a provider, or a Greenway Health partner, it's a snap to take your first steps with our FHIR API. Retrieving clinical data securely is almost as easy as browsing the web...",

    developer_main_section_card_title1: 'Learn our FHIR API',
    developer_main_section_card_description1:
      'Get access to our APIs and documentation to start building and integrating applications.',

    developer_main_section_card_title2: 'Build and test your app',
    developer_main_section_card_description2:
      'Use our isolated sandbox environments to test your apps with the real data before publishing them on Marketplace.',

    developer_main_section_card_title3: 'Deploy your app',
    developer_main_section_card_description3:
      'Launch, promote, and sell your apps on our Marketplace, our app store for customizations and integrations.',
  },
};
